import axios from "axios";

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || "",
    user: null,
    status: "",
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    status(state, payload) {
      state.status = payload;
    },
    auth_success(state, payload) {
      state.status = "success";
      state.token = payload.token;
      state.user = payload.user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
    },
    register_success(state, user) {
      state.status = "success";
      state.user = user;
    },
    update_user(state, user) {
      state.status = "success";
      state.user = user;
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "/auth/login",
          data: user,
          method: "POST",
        })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", "Bearer " + token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;

            const payload = {
              token: token,
              user: user,
            };
            commit("auth_success", payload);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    activate({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/user/activation/" + payload,
          method: "POST",
        })
          .then((resp) => {
            resolve(resp);
            commit("status", "ok");
          })
          .catch((err) => {
            reject(err);
            commit("status", "ok");
          });
      });
    },
    changePassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/user/change-password",
          data: payload,
          method: "POST",
        })
          .then((resp) => {
            resolve(resp);
            commit("update_user", resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateUser({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/user/",
          method: "GET",
        })
          .then((resp) => {
            const user = resp.data;

            commit("update_user", user);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            //localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "/user/create",
          data: user,
          method: "POST",
        })
          .then((resp) => {
            const user = resp.data;
            commit("register_success", user);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            //localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        localStorage.removeItem("token");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
  },
  getters: {
    isLoggedIn: (state) => state.token !== "",
    authStatus: (state) => state.status,
    user: (state) => state.user,
  },
};
